

import { MerchantAPIResponse } from '../models/merchantresponse.model';


export interface IMerchantState {
    Merchant: MerchantAPIResponse;
}

export const initialMerchantState: IMerchantState = {
    Merchant: null
};